import apiClient from './client'
import type { Athlete, CreateAthleteRequest, UpdateAthleteRequest } from '@/types'

export type DesktopAthlete = Athlete & { paused_at?: string }
export type AthleteUpdate = UpdateAthleteRequest & { paused?: boolean; group_id?: string }

export const athletesApi = {
  getByAssistantId: async (assistantId: string): Promise<DesktopAthlete[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/athletes`)
    return data
  },

  getById: async (_assistantId: string, id: string): Promise<DesktopAthlete> => {
    const { data } = await apiClient.get(`/athletes/${id}`)
    return data
  },

  create: async (assistantId: string, req: CreateAthleteRequest): Promise<DesktopAthlete> => {
    const { data } = await apiClient.post(`/assistants/${assistantId}/athletes`, req)
    return data
  },

  update: async (_assistantId: string, id: string, req: AthleteUpdate): Promise<DesktopAthlete> => {
    const { data } = await apiClient.put(`/athletes/${id}`, req)
    return data
  },

  delete: async (_assistantId: string, id: string): Promise<void> => {
    await apiClient.delete(`/athletes/${id}`)
  },

  search: async (assistantId: string, query: string): Promise<DesktopAthlete[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/athletes/search`, { params: { q: query } })
    return data
  },
}
